
import { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";

import MultiSelectDropdown from "../MultiSelectDropdown/MultiSelectDropdown";

import { visualizerActions } from "../../store";

import styles from './FilterMenu.module.css'


export default function FilterMenu() {
    const dispatch = useDispatch();

    const appliedFilters = useSelector((state) => state.visualizer.appliedFilters);
    const floorPlans = useSelector((state) => state.visualizer.floorPlanData);

    const [activeDropdown, setActiveDropdown] = useState(null);
    let communites = [];

    // Set dropdown options data
    const bedOptions = [{ value: 'all', label: "Clear all" }];
    const communityOptions = [{ value: 'all', label: "Clear all" }];
    const bathOptions = [{ value: 'all', label: "Clear all" }];
    const houseTypeOptions = [{ value: 'all', label: "Clear all" }];
    const squareFeetOptions = [
        { value: "all", label: "Clear all" },
        { value: "1000-1500", label: "1000 - 1500 Sqft" },
        { value: "1500-2000", label: "1500 - 2000 Sqft" },
        { value: "2000-2500", label: "2000 - 2500 Sqft" },
        { value: "2500-3000", label: "2500 - 3000 Sqft" },
        { value: "3000-3500", label: "3000 - 3500 Sqft" }
    ];

    // Fetch unique optoins from floorplans redux store
    floorPlans.forEach((plan) => {
        // get unique bed options
        if (bedOptions.findIndex(i => i["value"] === plan["beds"]) < 0)
            bedOptions.push({
                value: plan["beds"],
                label: plan["beds"] + " beds",
            });

        if (communityOptions.findIndex(i => i["value"] === plan["community"]) < 0){
            plan["community"].split(',').forEach(community => {
                community = community.trim();
                if (!communites.includes(community)) {
                    communites.push(community);
                    communityOptions.push({
                        value: community,
                        label: community,
                    });
                }
            });
        }

        // get uniuqe baths
        if (bathOptions.findIndex(i => i["value"] === plan["baths"]) < 0)
            bathOptions.push({
                value: plan["baths"],
                label: plan["baths"] + " baths",
            });

        //get unique types
        if (houseTypeOptions.findIndex(i => i["value"] === plan["type"]) < 0)
            houseTypeOptions.push({
                value: plan["type"],
                label: plan["type"],
            });
    });

    const compare = (a, b) => {
        if (b.value === "all") return true;
        return String(a.value).localeCompare(String(b.value));
    }

    // Sort dropdown options
    bedOptions.sort((a, b) => compare(a, b))
    communityOptions.sort((a, b) => compare(a, b))
    bathOptions.sort((a, b) => compare(a, b))
    houseTypeOptions.sort((a, b) => compare(a, b))

    // Toggle dropdown stat
    const toggleDropdown = (dropdownName) => {
        setActiveDropdown(prevState => prevState === dropdownName ? null : dropdownName);
    };

    // Handle dropdown option select
    const handleCheckboxChange = (e,label) => {
        const { name, value, checked} = e.target;
        if(value==='all'){
            dispatch(visualizerActions.clearAppliedFilterByName({ name }));
            toggleDropdown(null);
        }else{
            if (checked) {
                dispatch(visualizerActions.removeAppliedFilter({ name, value: 'all' }));
                if (!appliedFilters.some(filter => filter.name === name && filter.value === value)) {
                    dispatch(visualizerActions.addAppliedFilter({ name, value, label }));
                }
            } else {
                if (appliedFilters.some(filter => filter.name === name && filter.value === value)) {
                    dispatch(visualizerActions.removeAppliedFilter({ name, value }));
                }
            }
        }
        
    };

    // Get checked options
    const getCheckedOptions = (filterName) => {
        const checkedOptions = new Set(appliedFilters.filter(filter => filter.name === filterName).map(filter => filter.value));
        return checkedOptions;
    };

    return (
        <section className={styles.container}>

            <MultiSelectDropdown
                buttonLabel="Square Feet"
                options={squareFeetOptions}
                name="squareFeet"
                handleCheckboxChange={handleCheckboxChange}
                isActive={activeDropdown === "squareFeet"}
                toggleDropdown={toggleDropdown}
                checkedOptions={getCheckedOptions("squareFeet")}
            />
            <MultiSelectDropdown
                buttonLabel="Beds"
                options={bedOptions}
                name="beds"
                handleCheckboxChange={handleCheckboxChange}
                isActive={activeDropdown === "beds"}
                toggleDropdown={toggleDropdown}
                checkedOptions={getCheckedOptions("beds")}
            />
            <MultiSelectDropdown
                buttonLabel="Baths"
                options={bathOptions}
                name="baths"
                handleCheckboxChange={handleCheckboxChange}
                isActive={activeDropdown === "baths"}
                toggleDropdown={toggleDropdown}
                checkedOptions={getCheckedOptions("baths")}
            />
            <MultiSelectDropdown
                buttonLabel="Communities"
                options={communityOptions}
                name="communities"
                handleCheckboxChange={handleCheckboxChange}
                isActive={activeDropdown === "communities"}
                toggleDropdown={toggleDropdown}
                checkedOptions={getCheckedOptions("communities")}
            />
            <MultiSelectDropdown
                buttonLabel="House Type"
                options={houseTypeOptions}
                name="houseType"
                handleCheckboxChange={handleCheckboxChange}
                isActive={activeDropdown === "houseType"}
                toggleDropdown={toggleDropdown}
                checkedOptions={getCheckedOptions("houseType")}
            />
        </section>
    );
}

